import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader';
import axios from 'axios';

Vue.use(VueI18n);

let i18n = null;

export function initialize(lang) {
  i18n = new VueI18n({
    locale: lang, // set locale
    fallbackLocale: lang,
    messages, // set locale messages
    silentTranslationWarn: true,
    // missing: (locale, key, vm) => // TODO: call API to notify developers if it's in production
  });

  return i18n;
}

export function addMessages(lang, key, newMessages) {
  if (!i18n) {
    initialize(lang);
  }

  const currentMessages = i18n.getLocaleMessage(lang);

  i18n.setLocaleMessage(lang, Object.assign({}, currentMessages, { [key]: newMessages }));

  return i18n;
}

export async function loadFromServer(lang, key = 'cmrad') {
  try {
    const params = {
      key: key,
    };
    const response = await axios.get('/data/messages', { params });

    return addMessages(lang, key, response.data.data);
  } catch (err) {
    console.error('failed to load translations from the server', err);
  }

  return i18n;
}
